export default __webpack_public_path__ + "static/media/download.1d9d8db8.png";